var cartApp = angular.module("cart", ["ngRoute", "ngSanitize", "ui.bootstrap", "core"]);

cartApp.config(["$locationProvider", "$compileProvider", function ($locationProvider, $compileProvider) {
    $locationProvider.html5Mode(true);
}]);

cartApp.controller("Cart", ["$scope", "$injector", "$window", "$location", "$modal", "CartService", "constants", function ($scope, $injector, $window, $location, $modal, CartService, constants) {
    var self = this;
    var $timeout = $injector.get("$timeout");
    var updatingProducts = [];

    self.populateCart = function (details) {
        self.details = details;
    };

    self.hasProducts = function () {
        return _.has(self.details, "products") && self.details.products.length > 0;
    };

    self.hasAddToCartProducts = function () {
        return _.size(self.addedProducts) > 0 ? true : false;
    };

    self.afterAddingToCartAction = function () {
        if (self.hasAddToCartProducts && self.afterAddToCartShowCart && containedSuccessfulAdd()) {
            Notifications.closeLoading();
            $("#product-preview-modal").modal("hide");

            setTimeout(function() {
                var cartModal = $("#cart-modal");

                if (!(cartModal.data("bs.modal") || {})._isShown) {
                    cartModal.modal("show");
                }
            }, 500);
        }
    };

    var containedSuccessfulAdd = function () {
        return _.size(self.addedProducts) !== _.size(_.filter(self.addedProducts, {"success": false}));
    };

    self.justAddedClass = function (product) {
        return (self.hasAddToCartProducts() && _.some(self.addedProducts, {"slug": product.slug, "success": true})) ? "item-just-added" : "";
    };

    self.previewShowCartTotal = function () {
        return self.showCartTotalBesideCartIcon && self.details.canUserSeePrices;
    };

    self.previewShowEmptyCartMessage = function () {
        return self.showMessageBesideCartIconWhenEmpty && !self.hasProducts();
    };

    self.remove = function (product) {
        CartService.delete(product.sequence).then(function (result) {
            self.clearCartMessages();

            self.details = result.cartDetails;
            self.cartMessage = product.title + " " + result.message;
        });
    };

    self.clear = function (product) {
        CartService.clear().then(function (result) {
            self.clearCartMessages();

            self.details = result.cartDetails;
            self.showShippingEstimatesForm = false;
        });
    };

    self.hasCartMessage = function () {
        return !_.isEmpty(self.cartMessage);
    };

    self.clearCartMessages = function () {
        self.cartMessage = "";

        clearProductMessages();
        resetAddedProducts();
    };

    var clearProductMessages = function () {
        _.each(self.details.products, function (product) {
            product.updateMessage = "";
        });
    };

    var resetAddedProducts = function () {
        self.addedProducts = {};
        $(".cart-item").removeClass("item-just-added");
    };

    self.productIsNotAnAddon = function (isAddon) {
        return _.isNull(isAddon);
    };

    self.hasNonStockData = function (product) {
        return product.isNonStock && !_.isEmpty(product.nonStockData) && !product.isTrainingCourse;
    };

    self.showProductLink = function (product) {
        if (!product.isNonStock && self.hasConfiguration(product.configuration)) {
            return false;
        } else if (!product.isNonStock) {
            return true;
        }
    };

    self.showComments = function (product) {
        return self.showProductComments &&
            !product.isDigitalProduct &&
            self.productIsNotAnAddon(product.isAddon) &&
            !self.hasConfiguration(product.configuration);
    };

    self.isJsonComment = function (comment) {
        try {
            JSON.parse(comment);
        } catch (e) {
            return false;
        }

        return true;
    };

    self.hasSelectedAddons = function (product) {
        return !_.isEmpty(product.selectedAddons);
    };

    self.isEquipmentRegistryPart = function (product) {
        return product.isEquipmentRegistryPart;
    };

    self.increaseQty = function (product) {
        if (product.quantity !== maximumQuantityLimitForCart) {
            product.quantity += 1;
            self.productQtyChange(product);
        }
    };

    self.decreaseQty = function (product) {
        if (product.quantity !== 1) {
            product.quantity -=  1;
            self.productQtyChange(product);
        }
    };

    self.productQtyChange = function (product) {
        if (_.isNumber(product.quantity) && product.quantity <= maximumQuantityLimitForCart) {
            clearProductTimeout(product.sequence);

            var temp = {sequence: product.sequence, currentTimeout: null};

            temp.currentTimeout = $timeout(function () {
                update(product);
            }, 200);

            updatingProducts.push(temp);
        }
    };

    self.isTrainingCourse = function (product) {
        return product.isTrainingCourse;
    };

    var clearProductTimeout = function (sequence) {
        _.remove(updatingProducts, function (product) {
            if (product.sequence === sequence) {
                $timeout.cancel(product.currentTimeout);
                return true;
            }
        });
    };

    var update = function (product) {
        CartService.update(product).then(function (result) {
            self.clearCartMessages();

            var message = product.title + " " + result.message;

            self.details = setUpdateMessage(product.sequence, message, result.cartDetails);
        });
    };

    function setUpdateMessage(sequence, message, cartDetails) {
        var idx = _.findIndex(cartDetails.products, {"sequence": sequence});

        cartDetails.products[idx].updateMessage = message;

        return cartDetails;
    }

    self.updateComment = function (product) {
        update(product);
    };

    self.hasUpdateMessage = function (product) {
        return !_.isEmpty(product.updateMessage);
    };

    self.showAvailability = function (isNonStock) {
        return self.showProductAvailabilityInCartAndCheckout && !isNonStock;
    };

    self.hasTags = function (tags) {
        return !_.isEmpty(tags);
    };

    self.hasConfiguration = function (configuration) {
        return !_.isEmpty(configuration);
    };

    self.hasCustomImage = function (customImage) {
        return !_.isEmpty(customImage);
    };

    self.showBackorderNotice = function (product) {
        if (product.stock.isBackordered && !product.isNonStock) {
            return product.quantity > product.stock.available && product.stock.settings.showBackorderMessage;
        } else {
            return false;
        }
    };

    self.canSeePrices = function () {
        return self.details.canUserSeePrices && self.hasProducts();
    };

    self.canSeeListPrice = function (product) {
        return self.canSeePrices() && self.userHasAssignedCustomer && (product.listPrice > product.price);
    };

    self.canDisplayTotal = function () {
        return self.details.total > self.details.subtotal;
    };

    self.canSeeCustomerDiscount = function () {
        return self.canSeePrices() && self.details.discount > 0;
    };

    self.canSeeHandlingFee = function () {
        return self.canSeePrices() && self.details.handlingFee > 0;
    };

    self.showGuestEmail = function () {
        return !self.isLoggedIn && self.hasProducts() && self.allowNonLoggedInShoppersToCheckout && self.shouldRequestGuestEmail;
    };

    self.disableCheckoutButton = function () {
        return (self.showGuestEmail() && (_.isEmpty(self.guestEmail) || !_.includes(self.guestEmail, "@")) ? true : false);
    };

    self.forceLogin = function () {
        return !self.isLoggedIn && !self.allowNonLoggedInShoppersToCheckout;
    };

    self.goToCheckout = function () {
        if (self.showGuestEmail()) {
            CartService.saveGuestEmail({guestEmail: self.guestEmail}).then(function () {
                goTo("checkout");
            });
        } else {
            goTo("checkout");
        }
    };

    self.goToLogin = function () {
        goTo("login");
    };

    self.toggleShippingEstimatesForm = function () {
        self.showShippingEstimatesForm = !self.showShippingEstimatesForm;
    };

    self.canSeeTotalWeight = function () {
        return self.displayTotalWeightInCart && self.hasProducts();
    };

    self.showCloseToFreeShipping = function () {
        return !_.isEmpty(self.details.closeToFreeShippingMessage);
    };

    self.canPunchOut = function () {
        return self.isPunchOutSession && self.hasProducts();
    };

    self.punchOut = function () {
        CartService.punchOut().then(function (data) {
            if (data) {
                var postData = {};
                postData.apikey = data.apiKey;
                postData.params = data.params;
                postData.version = data.version;

                var form = "";
                _.forEach(data, function(value, key) {
                    form += "<input type='hidden' name=" + key + " value=" + value + ">";
                });

                $("<form action=" + data.redirectUri + " method='POST'>" + form + "</form>").appendTo("body").submit();
            }
        });
    };

    function goTo(destination) {
        if (!_.endsWith($location.absUrl(), destination)) {
            $window.location = base_index_url + destination;
        } else {
            hideModal();
        }
    }

    function hideModal() {
        $("#cart-modal").modal("hide");
    }

    (function () {
        resetAddedProducts();

        self.populateCart(constants.cartDetails);
        self.allowNonLoggedInShoppersToCheckout = constants.allowNonLoggedInShoppersToCheckout;
        self.guestEmail = constants.guestEmail;
        self.shouldRequestGuestEmail = constants.shouldRequestGuestEmail;
        self.isLoggedIn = constants.isLoggedIn;
        self.userHasAssignedCustomer = constants.userHasAssignedCustomer;
        self.showProductComments = constants.showProductComments;
        self.showProductAvailabilityInCartAndCheckout = constants.showProductAvailabilityInCartAndCheckout;
        self.showItemProductCountBesideCartIcon = constants.showItemProductCountBesideCartIcon;
        self.showCartTotalBesideCartIcon = constants.showCartTotalBesideCartIcon;
        self.showMessageBesideCartIconWhenEmpty = constants.showMessageBesideCartIconWhenEmpty;
        self.showShippingEstimatesForm = false;
        self.showNonStockData = true;
        self.afterAddToCartShowCart = constants.afterAddToCartShowCart;
        self.displayTotalWeightInCart = constants.displayTotalWeightInCart;
        self.isPunchOutSession = constants.isPunchOutSession;
    })();
}]);

cartApp.controller("ShippingEstimates", ["$scope", "ShippingEstimatesService", "constants", function ($scope, ShippingEstimatesService, constants) {
    var self = this;

    self.getEstimates = function (subtotal) {
        self.clearRatesAndErrors();
        self.showSpinner = true;

        self.params.destination.regionId = $scope.model.regionId;
        self.params.destination.countryId = $scope.model.countryId;

        var data = {
            destination: self.params.destination,
            subtotal: subtotal
        };

        ShippingEstimatesService.get(data).then(
            function (rates) {
                self.rateErrors = rates.errors;
                delete rates.errors;
                self.shippingCarrierRates = rates;
                self.showErrorMessage = (!self.hasRates() && !self.hasErrors());
            }
        ).then(
            function () {
                self.showSpinner = false;
            }
        );
    };

    self.hasRates = function () {
        return !_.isEmpty(self.shippingCarrierRates);
    };

    self.hasErrors = function () {
        return !_.isEmpty(self.rateErrors);
    };

    self.formValid = function () {
        return !(_.isEmpty(self.params.destination.address) || _.isEmpty(self.params.destination.postalCode) || _.isEmpty(self.params.destination.city) || !_.isNumber($scope.model.countryId) || _.isEmpty($scope.model.regionId));
    };

    self.clearRatesAndErrors = function () {
        self.shippingCarrierRates = {};
        self.rateErrors = {};
        self.showErrorMessage = false;
    };

    (function () {
        self.showSpinner = false;

        self.params = {};
        self.params.destination = {};
        self.params.destination.address = constants.shippingEstimates.address;
        self.params.destination.postalCode = constants.shippingEstimates.postalCode;
        self.params.destination.city = constants.shippingEstimates.city;

        $scope.model = {};
        $scope.model.countryId = constants.shippingEstimates.countryId;
        $scope.model.regionId = constants.shippingEstimates.regionId;

        self.clearRatesAndErrors();
    })();
}]);

cartApp.factory("CartService", ["HttpService", "rootUrl", function (HttpService, rootUrl) {
    var cartUrl = rootUrl + "cart/";
    var punchOutUrl = rootUrl + "po2go/punchOut";

    return {
        get: function () {
            return HttpService.get({
                url: cartUrl
            });
        },
        delete: function (sequence) {
            return HttpService.delete({
                url: cartUrl + sequence,
                loader: {
                    show: true
                }
            });
        },
        update: function (product) {
            return HttpService.put({
                url: cartUrl + product.sequence,
                data: product,
                loader: {
                    show: true
                }
            });
        },
        clear: function () {
            return HttpService.post({
                url: cartUrl + "clear",
                loader: {
                    show: true
                }
            });
        },
        saveGuestEmail: function (email) {
            return HttpService.post({
                url: cartUrl + "guest-email",
                data: email,
                loader: {
                    show: true
                }
            });
        },
        punchOut: function () {
            return HttpService.post({
                url: punchOutUrl,
                loader: {
                    show: true
                }
            });
        }
    };
}]);

cartApp.factory("ShippingEstimatesService", ["HttpService", function (HttpService) {
    return {
        get: function (data) {
            return HttpService.post({
                url: base_index_url + "shipping-estimates",
                data: {
                    data: data
                }
            });
        }
    };
}]);
